import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useLanguage } from "../context/LanguageContext";

const AccessibilityWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();
  
  // Učitavanje početnih postavki iz localStorage
  const [fontSize, setFontSize] = useState(() => Number(localStorage.getItem("acc-font-size")) || 100);
  const [contrast, setContrast] = useState(() => localStorage.getItem("acc-contrast") === "true");
  const [dyslexicFont, setDyslexicFont] = useState(() => localStorage.getItem("acc-dyslexic") === "true");
  const [underlineLinks, setUnderlineLinks] = useState(() => localStorage.getItem("acc-underline") === "true");

  useEffect(() => {
    // Primjena i spremanje postavki
    document.documentElement.style.fontSize = `${fontSize}%`;
    localStorage.setItem("acc-font-size", fontSize);
    
    if (contrast) {
      document.body.classList.add("high-contrast");
      localStorage.setItem("acc-contrast", "true");
    } else {
      document.body.classList.remove("high-contrast");
      localStorage.setItem("acc-contrast", "false");
    }

    if (dyslexicFont) {
        document.body.style.fontFamily = "'OpenDyslexic', sans-serif";
        localStorage.setItem("acc-dyslexic", "true");
    } else {
        document.body.style.fontFamily = "var(--font-main)";
        localStorage.setItem("acc-dyslexic", "false");
    }

    if (underlineLinks) {
        document.body.classList.add("underline-links");
        localStorage.setItem("acc-underline", "true");
    } else {
        document.body.classList.remove("underline-links");
        localStorage.setItem("acc-underline", "false");
    }
  }, [fontSize, contrast, dyslexicFont, underlineLinks]);

  const toggleWidget = () => setIsOpen(!isOpen);

  const reset = () => {
    setFontSize(100);
    setContrast(false);
    setDyslexicFont(false);
    setUnderlineLinks(false);
  };

  return (
    <div style={{ position: "fixed", bottom: "80px", left: "20px", zIndex: 10000 }}>
      {/* Glavni gumb */}
      <Button 
        onClick={toggleWidget}
        style={{ 
          width: "50px", 
          height: "50px", 
          borderRadius: "50%", 
          backgroundColor: "#7772f1", 
          border: "none",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "24px"
        }}
        title={t("accessibility.title")}
        aria-label={t("accessibility.title")}
      >
        ♿
      </Button>

      {/* Izbornik */}
      {isOpen && (
        <div style={{ 
          position: "absolute", 
          bottom: "60px", 
          left: "0", 
          width: "250px", 
          backgroundColor: "#fff", 
          borderRadius: "15px", 
          padding: "20px", 
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          border: "1px solid #eee"
        }}>
          <h6 className="mb-3" style={{ fontWeight: "800", color: "#1a2141" }}>{t("accessibility.title")}</h6>
          
          <div className="d-grid gap-2">
            <Button variant="outline-primary" size="sm" onClick={() => setFontSize(f => f + 10)}>
              {t("accessibility.increaseFont")}
            </Button>
            <Button variant="outline-primary" size="sm" onClick={() => setFontSize(f => Math.max(80, f - 10))}>
              {t("accessibility.decreaseFont")}
            </Button>
            <Button 
                variant={contrast ? "primary" : "outline-primary"} 
                size="sm" 
                onClick={() => setContrast(!contrast)}
            >
              {t("accessibility.contrast")}
            </Button>
            <Button 
                variant={dyslexicFont ? "primary" : "outline-primary"} 
                size="sm" 
                onClick={() => setDyslexicFont(!dyslexicFont)}
            >
              {t("accessibility.dyslexic")}
            </Button>
            <Button 
                variant={underlineLinks ? "primary" : "outline-primary"} 
                size="sm" 
                onClick={() => setUnderlineLinks(!underlineLinks)}
            >
              {t("accessibility.underline")}
            </Button>
            <hr />
            <Button variant="link" size="sm" onClick={reset} style={{ color: "#dc3545" }}>
              {t("accessibility.reset")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccessibilityWidget;
